import withPageContainer from '../shared/page-container/with-page-container';
import withIntl from '../shared/intl-hoc';

const navigation = [
	{
		href: 'bm-accounts/list',
		name: 'List',
		permission: null
	},
	{
		href: 'bm-accounts/categories',
		name: 'Categories',
		permission: null
	}
];

export default Main => withPageContainer(withIntl(Main), {
	name: 'BM Accounts',
	tabs: navigation,
	permission: null
});


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/bm-accounts/wrap-main.js